import axios, { AxiosResponse } from 'axios';
import { CarlineBase } from 'src/types';
import { getDataUrl, reportErrorSentry } from 'src/bff';

export const getCarlines = async (isVo?: boolean): Promise<CarlineBase[]> => {
  try {
    const dataUrl = getDataUrl();
	const requestUrl = isVo ? `${dataUrl}/getVOCarlines` : `${dataUrl}/getCarlines`;
  
    const response: AxiosResponse<{ carlines: CarlineBase[] }> = await axios.get(requestUrl);
    return response.data.carlines;
    
  } catch (error) {
    reportErrorSentry(error);
    return null;
  }
};
